<form [formGroup]="form">
    <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
      <h2 class="title m-0" fxFlex="auto">{{ 'Change Password' }}</h2>
      <span fxFlex></span>
      <button class="text-secondary ml-4" mat-dialog-close mat-icon-button type="button">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>
  
    <mat-divider class="-mx-6 text-border mb-2"></mat-divider>
  
    <mat-dialog-content fxLayout="column" class="pt-3">
      <mat-form-field fxFlex="auto">
        <mat-label>Old Password</mat-label>
        <input [type]="oldInputType" matInput [formControl]="oldPassword" name="old_password" required (keypress)="checkWhitSpaces($event)">
        <mat-error *ngIf="oldPassword.hasError('required')">This field is required</mat-error>
       
      </mat-form-field>
      <mat-form-field fxFlex="auto">
        <mat-label>New Password</mat-label>
        <input [type]="newInputType" matInput formControlName="newPassword" name="new_password" required minlength="8" (keypress)="checkWhitSpaces($event)">
        <mat-error *ngIf="form.get('newPassword').hasError('required')">This field is required</mat-error>
        <mat-error  *ngIf="form.get('newPassword').hasError('minlength')">Password must be atleast 8 characters</mat-error>
        <mat-error *ngIf="form.get('newPassword').hasError('pattern') && !form.get('newPassword').hasError('minlength')"> Please include atleast one uppercase and smallcase letter, number and mentioned special character (!@#$%^&*()_+-=)</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="auto">
        <mat-label>Re-Enter Password</mat-label>
        <input [type]="cpInputType" matInput formControlName="reEnterPassword"  name="reEnterPassword" (keypress)="checkWhitSpaces($event)"
          required>
        <!-- <mat-error *ngIf="form.get('reEnterPassword').errors && (form.get('reEnterPassword').touched)"> </mat-error> -->
        <mat-error *ngIf="form.get('reEnterPassword').hasError('mustMatch')">Password does not match</mat-error>
      </mat-form-field>
    </mat-dialog-content>
  
    <mat-divider class="-mx-6 text-border"></mat-divider>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="start center"  align="center">
      <span fxFlex></span>
      <div class="-mx-1 flex items-center">
        <button color="primary" mat-raised-button [disabled]="!form.valid || !oldPassword.valid" type="button" (click)="changePassword()">Update</button>
      </div>
      
      <!-- <p>Note : The above mentioned password will be sent to the user by email.</p> -->
    </mat-dialog-actions>
  </form>